import SweetAlert from "sweetalert2"
export function showWarningAlert({
  icon = "warning",
  title,
  text,
  confirmButtonText = "OK",
  onConfirm,
}: {
  icon?: "warning" | "success" | "error" | "info" | "question";
  title: string;
  text: string;
  confirmButtonText?: string;
  onConfirm?: () => void;
  confirmButtonColor?:string
}) {
  SweetAlert.fire({
    icon,
    title,
    text,
    confirmButtonColor: "var(--theme-default)",
    confirmButtonText,
    showCancelButton: true,
  }).then((result:any) => {
    if (result.isConfirmed) {
      if (onConfirm) onConfirm();
    }
  });
}